/* tslint:disable */
/* eslint-disable */
/**
 * OMS API
 * The documentation for the Order Management System (OMS) backend API.
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// @ts-ignore
import * as runtime from '../runtime';
// @ts-ignore
import type {
// @ts-ignore
  Promotion,
// @ts-ignore
  PromotionCreateRequest,
// @ts-ignore
  PromotionListResponse,
// @ts-ignore
  PromotionUpdateRequest,
} from '../models/index';
// @ts-ignore
import {
// @ts-ignore
    PromotionFromJSON,
// @ts-ignore
    PromotionToJSON,
// @ts-ignore
    PromotionCreateRequestFromJSON,
// @ts-ignore
    PromotionCreateRequestToJSON,
// @ts-ignore
    PromotionListResponseFromJSON,
// @ts-ignore
    PromotionListResponseToJSON,
// @ts-ignore
    PromotionUpdateRequestFromJSON,
// @ts-ignore
    PromotionUpdateRequestToJSON,
} from '../models/index';

export interface CreatePromotionRequest {
    promotionCreateRequest: PromotionCreateRequest;
}

export interface DeletePromotionRequest {
    id: string;
}

export interface GetPromotionRequest {
    id: string;
}

export interface ListPromotionsRequest {
    query?: string;
    limit?: number;
    offset?: number;
    supplierId?: Array<string>;
}

export interface UpdatePromotionRequest {
    id: string;
    promotionUpdateRequest: PromotionUpdateRequest;
}

/**
 * 
 */
export class PromotionsApi extends runtime.BaseAPI {

    /**
     * Create a new promotion
     */
    async createPromotionRaw(requestParameters: CreatePromotionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Promotion>> {
        if (requestParameters.promotionCreateRequest === null || requestParameters.promotionCreateRequest === undefined) {
            throw new runtime.RequiredError('promotionCreateRequest','Required parameter requestParameters.promotionCreateRequest was null or undefined when calling createPromotion.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/promotions`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PromotionCreateRequestToJSON(requestParameters.promotionCreateRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PromotionFromJSON(jsonValue));
    }

    /**
     * Create a new promotion
     */
    async createPromotion(requestParameters: CreatePromotionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Promotion> {
        const response = await this.createPromotionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete a promotion by ID
     */
    async deletePromotionRaw(requestParameters: DeletePromotionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling deletePromotion.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/promotions/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a promotion by ID
     */
    async deletePromotion(requestParameters: DeletePromotionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deletePromotionRaw(requestParameters, initOverrides);
    }

    /**
     * Get details of a specific promotion
     */
    async getPromotionRaw(requestParameters: GetPromotionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Promotion>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getPromotion.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/promotions/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PromotionFromJSON(jsonValue));
    }

    /**
     * Get details of a specific promotion
     */
    async getPromotion(requestParameters: GetPromotionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Promotion> {
        const response = await this.getPromotionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get a list of promotions
     */
    async listPromotionsRaw(requestParameters: ListPromotionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PromotionListResponse>> {
        const queryParameters: any = {};

        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.supplierId) {
            queryParameters['supplierId'] = requestParameters.supplierId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/promotions`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PromotionListResponseFromJSON(jsonValue));
    }

    /**
     * Get a list of promotions
     */
    async listPromotions(requestParameters: ListPromotionsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PromotionListResponse> {
        const response = await this.listPromotionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a promotion by ID
     */
    async updatePromotionRaw(requestParameters: UpdatePromotionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Promotion>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updatePromotion.');
        }

        if (requestParameters.promotionUpdateRequest === null || requestParameters.promotionUpdateRequest === undefined) {
            throw new runtime.RequiredError('promotionUpdateRequest','Required parameter requestParameters.promotionUpdateRequest was null or undefined when calling updatePromotion.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/promotions/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: PromotionUpdateRequestToJSON(requestParameters.promotionUpdateRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PromotionFromJSON(jsonValue));
    }

    /**
     * Update a promotion by ID
     */
    async updatePromotion(requestParameters: UpdatePromotionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Promotion> {
        const response = await this.updatePromotionRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
